import React, { useState, useEffect, createRef } from "react";
import { Button, Col, Row, Spinner, UncontrolledTooltip } from "reactstrap";
import { getExtentionFile, isImageFile } from "../helpers/utility";
import Dropzone from "react-dropzone";
import moment from "moment";

function UploadFile({
    id,
    disableEdit,
    handleAcceptedFiles,
    typeFile,
    file,
    titleDocument,
    showPreviewImage,
    processUpload,
    identity,
}) {
    const dropzoneRef = createRef();
    const openDialog = () => {
        if (dropzoneRef.current) {
            dropzoneRef.current.open();
        }
    };

    const download = (file) => {
        fetch(file, {
            method: "GET",
            headers: {},
        })
            .then((response) => {
                response.arrayBuffer().then(function (buffer) {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `${identity.replaceAll(" ", "-")}-${typeFile.replaceAll("_", "-")}-${moment().format(
                            "YYYY-MM-DD"
                        )}.${getExtentionFile(file)}`
                    );
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <Dropzone
            ref={dropzoneRef}
            noClick
            noKeyboard
            onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles, typeFile)}>
            {({ getRootProps, getInputProps }) => (
                <div
                    {...getRootProps({ className: "dropzone" })}
                    style={{ backgroundColor: disableEdit ? "#f4f4f4" : "#ffffff" }}>
                    <input {...getInputProps()} />
                    <div className="p-1 px-2">
                        <Row className="align-items-center">
                            <Col className="col-auto">
                                <div className="avatar-sm font-weight-bold mr-3">
                                    <span className="avatar-title rounded bg-soft-primary text-primary">
                                        {file ? (
                                            <i
                                                className={`${
                                                    isImageFile(file) ? "uil-scenery" : "uil-file-alt"
                                                } font-size-20`}></i>
                                        ) : (
                                            <i className="uil-folder-upload font-size-20"></i>
                                        )}
                                    </span>
                                </div>
                            </Col>
                            <Col className="pl-0">
                                <span className="text-muted font-weight-bold">{titleDocument}</span>
                                <p className="mb-0">format file: {file ? getExtentionFile(file) : "-"}</p>
                            </Col>
                            <Col className="col-auto">
                                {processUpload && processUpload === typeFile && (
                                    <Spinner color={"#369378"} size="sm" className="mr-2" />
                                )}
                                {!processUpload && !disableEdit && (
                                    <div>
                                        <a
                                            id={`btn-dl-${id}`}
                                            className="btn btn-link text-primary btn-lg p-0 ml-1"
                                            onClick={openDialog}>
                                            <i className="uil uil-upload-alt font-size-20"></i>
                                        </a>
                                        <UncontrolledTooltip placement="bottom" target={`btn-dl-${id}`}>
                                            Unggah Dokumen
                                        </UncontrolledTooltip>
                                    </div>
                                )}

                                {file && !processUpload && disableEdit && isImageFile(file) && (
                                    <div className="d-flex">
                                        <div>
                                            <button
                                                className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                id={`btn-d-${id}`}
                                                href="#"
                                                onClick={() => download(file)}>
                                                <i className="uil uil-cloud-download font-size-20"></i>
                                            </button>
                                        </div>
                                        <div>
                                            <a
                                                className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                id={`btn-d-${id}`}
                                                onClick={showPreviewImage}>
                                                <i className="uil uil-eye font-size-20"></i>
                                            </a>
                                            <UncontrolledTooltip placement="bottom" target={`btn-d-${id}`}>
                                                Lihat Dokumen
                                            </UncontrolledTooltip>
                                        </div>
                                    </div>
                                )}
                                {file && !processUpload && disableEdit && !isImageFile(file) && (
                                    <div className="d-flex">
                                        <div>
                                            <button
                                                className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                id={`btn-d-${id}`}
                                                href="#"
                                                onClick={() => download(file)}>
                                                <i className="uil uil-cloud-download font-size-20"></i>
                                            </button>
                                        </div>
                                        <div>
                                            <a
                                                href={file}
                                                target="_blank"
                                                className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                id={`btn-d-${id}`}>
                                                <i className="uil uil-eye font-size-20"></i>
                                            </a>
                                            <UncontrolledTooltip placement="bottom" target={`btn-d-${id}`}>
                                                Lihat Dokumen
                                            </UncontrolledTooltip>
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </Dropzone>
    );
}

export default UploadFile;
